"use client";

import TextbookPromo, { type TextbookNav } from "@/components/textbook/TextbookPromo";

export default function TextbookBrowseClient({ initialNav }: { initialNav?: TextbookNav | null }) {
  return <TextbookPromo initialNav={initialNav} />;
}
